import * as angular from 'angular';

"use strict";

angular.module('HelpModeModule', [])

export default 'HelpModeModule';